export function addSchemeToDomain(domain: string) {
  return domain.includes('://') ? domain : `https://${domain}`;
}
